import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=509b87b8&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=509b87b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b87b8",
  null
  
)

export default component.exports